export default {"src":"/_next/static/media/kite.9cd27345.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};